import {z} from 'zod'

export const formSchema = z.object({
  origin_uf: z.string().optional(),
  origin_ibge: z.string().optional(),
  destination_uf: z.string().optional(),
  destination_ibge: z.string().optional(),
  status: z.string().optional(),
  carrier_id: z.string().optional(),
});

export type FormSchema = z.infer<typeof formSchema>;